<template>
  <div data-app class="object-menu-container" :style="[xPosition, yPosition]">
    <v-list subheader class="pa-0">
      <v-list-item
        v-for="item in menuItems"
        :key="item.title"
        v-if="item.visible"
        @click="executeAction(item.id)"
        class="px-1"
        style="height: 24px; min-height: 24px"
      >
        <v-icon size="17" class="mr-2">{{ item.icon }}</v-icon>

        <span class="pr-2 object-menu-title">{{ item.title }}</span>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  name: "HierarchyObjectMenu",

  props: {
    /**
     * Selected object
     */
    objectSelected: {
      type: Object,
      required: true
    },

    /**
     * Horizontal click position
     */
    x: Number,

    /**
     * Vertical click position
     */
    y: Number
  },

  computed: {
    /**
     * Defines the available buttons in the object menu
     * @returns {[{visible: boolean, icon: string, id: string, title: VueI18n.TranslateResult}, {visible: boolean, icon: string, id: string, title: string}, {visible: boolean, icon: string, id: string, title: VueI18n.TranslateResult}]}
     */
    menuItems() {
      return [
        {
          id: "focus",
          icon: "filter_center_focus",
          title: this.$i18n.t("Focus"),
          visible: true
        },
        {
          id: "view",
          icon: "mdi-table",
          title: this.$i18n.tc("Property", 2),
          visible: this.objectSelected.type === "node"
        },
        {
          id: "open-on-workspace",
          icon: "filter_none",
          title: this.$i18n.t("OpenOnWorkspace"),
          visible: this.objectSelected.type === "node"
        }
      ];
    },

    /**
     * Finds and stores the position where the object menu should be place in the x axis.
     *
     * @returns {{right: number}|{left: string}}
     * of the map.
     */
    xPosition() {
      return { left: this.x + 10 + "px" };
    },

    /**
     * Finds and stores the position where the object menu should be place in the y axis.
     *
     * @returns {{top: string}|{bottom: number}}
     */
    yPosition() {
      return { top: this.y + "px" };
    }
  },

  methods: {
    ...mapActions(["fetchObjectByUUID", "SET_OBJECT_TO_ZOOM_ON_MAP"]),

    /**
     * Whenever one of the options is clicked, it executes the intended action
     * @param id
     */
    executeAction(id) {
      if (id) {
        switch (id) {
          case "focus":
            this.centerObjectOnMap(this.objectSelected.geom);
            break;
          case "view":
            this.openForm();
            break;
          case "open-on-workspace":
            this.openOnWorkspace();
            break;
        }
      }
    },

    /**
     * centers object on map (internal API parameters)
     */
    async centerObjectOnMap(objectGeoJson) {
      this.$nextTick(() => {
        this.SET_OBJECT_TO_ZOOM_ON_MAP(undefined).then(() => {
          this.SET_OBJECT_TO_ZOOM_ON_MAP(objectGeoJson);
          this.$emit("close");
        });
      });
    },

    /**
     * Opens the object's form, when the user clicks the View button, if the user has View permission for that kind
     * of object.
     *
     */
    async openForm() {
      let layer = this.objectSelected.table;

      if (this.objectSelected.table === "fc_technical_local") {
        layer = this.objectSelected.layer;
      }
      let endpoint = this.$store.getters.getLayerEndpoint(layer);
      let typeName = this.$store.getters.getLayerTypeName(layer);

      let objectData = {
        type: typeName,
        uuid: this.objectSelected.uuid,
        endpoint: endpoint,
        layerName: layer,
        coordinates: this.objectSelected.geom.coordinates,
        marked: false,
        label: this.objectSelected.label
      };
      bus.$emit("open-form", objectData);
      this.$emit("close");
    },

    /**
     * Sends an event with the object's data, to be shown in a workspace where the object is contained
     * @returns {Promise<void>}
     */
    async openOnWorkspace() {
      let layer = this.objectSelected.table;

      if (this.objectSelected.table === "fc_technical_local") {
        layer = this.objectSelected.layer;
      }

      bus.$emit("open-on-workspace", {
        uuid: this.objectSelected.uuid,
        layer: layer,
        coordinates: this.objectSelected.geom
      });
    }
  }
};
</script>

<style scoped>
.object-menu-container {
  background: #ffffff;
  position: absolute;
  z-index: 25;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid #f5f5f5;
  width: 160px;
}

.object-menu-title {
  font: normal normal normal 12px/12px Segoe UI;
  color: #32383d;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/LeftSidebar/HierarchyObjectMenu.vue